/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdOverlayProps } from './type';

export const overlayDefaultProps: TdOverlayProps = {
  duration: 300,
  preventScrollThrough: true,
  visible: false,
  zIndex: 1000,
};
